export const calculateLoan = (loan, loanSearch) => {
  if (!loanSearch) {
    return null;
  }
  const matchingTier = loan.loantiers.find(t => {
    return ((loanSearch.amount >= t.minamount) && (loanSearch.amount <= t.maxamount));
  });
  const fallbackTier = loan.loantiers[0];
  const calculationTier = matchingTier || fallbackTier;
  const calculationAmount = matchingTier ? loanSearch.amount : fallbackTier.minamount;
  const interestRate = calculationTier.interest_rate / 1200;
  const termInMonths = loanSearch.term * 12;
  const multiplier = Math.pow(1 + interestRate, termInMonths);
  const monthlyRepayment = ((calculationAmount * multiplier * interestRate) / (multiplier - 1));
  const totalRepayment = monthlyRepayment * termInMonths;
  return { ...loan, ...{ apr: calculationTier.apr, interestRate: interestRate * 1200, monthlyRepayment, principal: calculationAmount, matchingTier, termInMonths, totalRepayment } };
};
